export const getStyles = () => ({
  container: {
    fontSize: '14px',
    lineHeight: '19px',
  },
  lists: {
    display: 'flex',
    gap: '8px',
    height: '300px',
  },
});
